import React, { useState, useEffect, useContext } from "react";
import Alert from "@mui/material/Alert";
import Loading from "../components/Loading";
/* import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react"; */
import { api } from "../services/api";
import "./Profile.css";
import { useMediaQuery } from "react-responsive";
import Perfil from "../components/perfil/perfil_informacion";
import { DrawerContext } from "../components/navbar/DrawerContext";
import withAuthenticationRequired from "../components/ProtectedRoutes/withAuthenticationRequired";

const ProfileComponent = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    direccion: "",
    ciudad: "",
    provincia: "",
    cp: "",
    pais: "",
  });

  const { setDrawerOpen } = useContext(DrawerContext);
  const isMobile = useMediaQuery({ query: "(max-width: 770px)" });

  useEffect(() => {
    if (isMobile) {
      setDrawerOpen(true);
    }
  }, [isMobile, setDrawerOpen]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await api.usuarios.getUsuario();
        if (response.status === "success") {
          setUsuario(response.data.usuario);
        }
      } catch (error) {
        setError(error.message || "Error al cargar el usuario");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    if (usuario) {
      setFormData({
        nombre: usuario.nombre || "",
        apellido: usuario.apellido || "",
        telefono: usuario.telefono || "",
        direccion: usuario.direccion || "",
        ciudad: usuario.ciudad || "",
        provincia: usuario.provincia || "",
        cp: usuario.cp || "",
        pais: usuario.pais || "",
      });
    }
  }, [usuario]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <div className="container-fluid">
      <div className="row pt-4">
        <div className={isMobile ? "col-12" : "col-10 offset-1"}>
          <Perfil usuario={usuario} />
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});